import { Box, Flex, Icon, IconButton, Input, InputGroup, InputLeftElement, useDisclosure } from '@chakra-ui/react'
import { useQueryClient } from 'react-query'
import { ArrowLeft, Filter, Search } from '../icons/icons'
import CommunityFilterModal from '../modals/CommunityFilterModal'
import { useUserWrapperContext } from '../wrappers/UserWrapper'
import { getCommunityFilterCount, type CommunityFilters } from '../../functions/communityFilters'

const UserCommunitySearchHeader = () => {
  const { searchCommunity, setSearchCommunity, searchActive, setSearchActive, communityFilters, setCommunityFilters } =
    useUserWrapperContext()

  const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure()
  const queryClient = useQueryClient()

  const filterCount = getCommunityFilterCount(communityFilters)
  const showCountBadge = filterCount > 0

  // Apply filters and trigger refetch
  const handleApplyFilters = (filters: CommunityFilters) => {
    setCommunityFilters(filters)
    // Invalidate query to trigger a refetch with new filters
    queryClient.invalidateQueries('getSearchedUsers')
  }

  return (
    <>
      <Flex gap="8px" mt="10px">
        {searchActive && (
          <IconButton
            minW="40px"
            h="40px"
            variant="light"
            aria-label="new chat"
            onClick={() => {
              setSearchActive(false)
              setSearchCommunity('')
            }}
            icon={
              <Icon width="20px" height="19px" viewBox="0 0 23 20">
                <ArrowLeft color="#171C22" />
              </Icon>
            }
          />
        )}
        <InputGroup>
          <InputLeftElement>
            <Icon width="18" height="18" viewBox="0 0 18 18">
              <Search color="#7E8B9A" />
            </Icon>
          </InputLeftElement>
          <Input
            w="100%"
            value={searchCommunity}
            onChange={(e) => setSearchCommunity(e.target.value)}
            onFocus={() => setSearchActive(true)}
            //onBlur={() => setSearchActive(false)}
            variant="filled"
            placeholder="Search for friends and coaches..."
          />
        </InputGroup>

        {searchActive && (
          <Flex position="relative" overflow="visible" flexShrink={0}>
            <IconButton
              aria-label="filters"
              variant="light"
              borderRadius="10px"
              icon={
                <Icon width="25px" height="26px" viewBox="0 0 27 28" mb="4px" ml="3px">
                  <Filter color={showCountBadge ? '#06C270' : 'black'} />
                </Icon>
              }
              onClick={onFilterOpen}
            />
            {filterCount > 0 && (
              <Box
                borderRadius="100px"
                bg="black"
                w="20px"
                h="20px"
                p="2px"
                position="absolute"
                top="-6px"
                right="-6px"
                color="white"
                fontSize="12px"
                display={showCountBadge ? 'flex' : 'none'}
                alignItems="center"
                justifyContent="center"
              >
                {filterCount}
              </Box>
            )}
          </Flex>
        )}
      </Flex>

      <CommunityFilterModal
        isOpen={isFilterOpen}
        onClose={onFilterClose}
        onApply={handleApplyFilters}
        initialFilters={communityFilters}
      />
    </>
  )
}

export default UserCommunitySearchHeader
